export enum TimeRange {
  MORNING = 'MORNING',
  AFTERNOON = 'AFTERNOON',
  EVENING = 'EVENING',
  ALL_DAY = 'ALL_DAY'
}
